import React from 'react'

interface ProgressBarProps {
  value: number
  label?: string
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, label }) => {
  const clamped = Math.max(0, Math.min(100, Math.round(value)))
  return (
    <div className="flex items-center gap-2">
      <div
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
        className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden"
      >
        <div
          className={`h-full rounded-full transition-all ${clamped === 100 ? 'bg-green-500' : 'bg-primary-600'}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className="text-xs font-medium text-gray-600">{clamped}%</span>
    </div>
  )
}

export default ProgressBar
